import React, { useState } from "react";
import counterBack from "../../img/counterBack.svg";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import _ from "lodash";
import classNames from "classnames";
import { setActiveEvent } from "../dashboard/actions";
import { motion } from "../dashboard/actions";

const Navigation = (props) => {
  const { events, subscription } = props;

  const [showEventList, setShowEventList] = useState(true);

  if (_.isEmpty(events) || !subscription || !subscription.plan) {
    return null;
  }

  const setActiveEvent = (eventId) => {
    props.setActiveEvent(eventId);
  };

  return (
    <div
      className={classNames(
        "navigationSystem",
        props.showResponsiveNav ? "open" : "close"
      )}
    >
      <div className="responsiveCloseBtn" onClick={()=>{props.setShowResponsiveNav(false)}}>
        <span className="icon-cross"></span>
      </div>
      <div className="promotions organizer font-size_14">
        <div className="activePlan whiteColor originalBackground">
          <div className="planTitle blockInline">
            پلن فعال
            <p className="redColor">{subscription.plan.name}</p>
          </div>
          <div className="upgradeButton redBackground blockInline">
            <span className="icon icon-level-up"></span> تمدید یا ارتقا
          </div>
        </div>
        {subscription.plan.isUnlimited ? (
          <div className="daysLeft">
            <div className="daysLeftInner whiteColor greenBackground">
              <div className="planTitle blockInline">
                <div className=" blockInline middleContext">
                  <span className="dayContainer centerText middleContext">
                    <img src={counterBack} />
                    <span className="countNumber relative">۵</span>
                  </span>
                  <span className="dayContainer centerText middleContext">
                    <img src={counterBack} />
                    <span className="countNumber relative">۶</span>
                  </span>
                  <span className="dayContainer centerText middleContext">
                    <img src={counterBack} />
                    <span className="countNumber relative">۳</span>
                  </span>
                </div>
                <div className="blockInline middleContext dayLeftTitle">
                  روز مانده
                  <p className="whiteColor lightFont">از اعتبار</p>
                </div>
              </div>
              <div className="upgradeButton whiteBackground greenColor blockInline">
                <span className="icon icon-clock"></span>
                تمدید
              </div>
            </div>
            <div className="daysLeftShadow"></div>
          </div>
        ) : null}
      </div>
      <div className="mainNavigation organizer">
        <div className="dashboardItem relative">
          <Link to={`/dashboard/${props.activeEvent}`}>
            <div
              className={classNames("whiteBox pointerCursor", {
                greenColor: props.location.pathname.startsWith("/dashboard"),
              })}
            >
              <span className="icon icon-dashboard middleContext halfLeftMargin"></span>
              داشبورد
              <span className="icon icon-arrow-left font-size_14 leftFloat arrowPosition"></span>
            </div>
          </Link>
        </div>
        <div className="listItems font-size_18">
          <ul>
            <li>
              <span className="icon icon-event font-size_24 middleContext boldFont grayResponsive"></span>{" "}
              <span className="grayResponsive">رویداد ها</span>
              <span
                className={classNames(
                  "icon icon-arrow-down font-size_14 leftFloat arrowPosition eventListPointer pointerCursor grayResponsive",
                  showEventList ? "" : "rotateDown"
                )}
                onClick={() => {
                  setShowEventList(!showEventList);
                }}
              ></span>
              <ul className={!showEventList && "tempDisable"}>
                <li className="addNew addNewEvent greenColor pointerCursor">
                  <Link to="/events/new">
                    <span className="icon icon-add_event halfLeftMargin"></span>
                    افزودن رویداد جدید
                  </Link>
                </li>
                {_.map(events, (e, k) => (
                  <li
                    key={k}
                    className={classNames("whiteBox", {
                      active: k == props.activeEvent,
                    })}
                    onClick={(e) => setActiveEvent(k)}
                  >
                    <div className="eventTitle blockInline">
                      <span className="line-clamp line-clamp-2">{e.name}</span>
                      <p className="font-size_12 lightFont">{`از ${e.jalaliStartDate} تا ${e.jalaliEndDate}`}</p>
                    </div>
                    <Link to={`/events/${k}`}>
                      <span className="icon icon-edit font-size_14 pointerCursor" />
                    </Link>
                    <span className="icon icon-arrow-left font-size_14 leftMargin" />
                  </li>
                ))}
              </ul>
            </li>

            <li>
              <span className="icon icon-book font-size_24 middleContext boldFont"></span>{" "}
              کتاب ها
              <span className="icon icon-arrow-down font-size_14 leftFloat arrowPosition"></span>
              <ul className="normalInnerList">
                <li
                  className={classNames({
                    greenColor:
                      props.location.pathname.startsWith("/books/new"),
                  })}
                >
                  <Link to="/books/new" className="pointerCursor">
                    افزودن کتاب جدید{" "}
                    <span className="icon icon-add-book leftFloat font-size_24"></span>
                  </Link>
                </li>
                <li
                  className={classNames({
                    greenColor:
                      props.location.pathname.toLowerCase() === "/books",
                  })}
                >
                  <Link to="/books" className="pointerCursor">
                    لیست کامل کتاب
                  </Link>
                </li>
              </ul>
            </li>

            <li
              className={classNames({
                greenColor: props.location.pathname.startsWith("/customers"),
              })}
            >
              <Link to="/customers" className="pointerCursor">
                <span className="icon icon-customer font-size_24 middleContext boldFont"></span>{" "}
                مشتریان
                <span className="icon icon-arrow-down font-size_14 leftFloat arrowPosition"></span>
              </Link>
            </li>
            <li
              className={classNames({
                greenColor: props.location.pathname.startsWith("/orders"),
              })}
            >
              <Link to="/orders" className="pointerCursor">
                <span className="icon icon-orders font-size_24 middleContext boldFont"></span>{" "}
                سفارشات
                <span className="icon icon-arrow-down font-size_14 leftFloat arrowPosition"></span>
              </Link>
            </li>
            <li
              className={classNames({
                greenColor: props.location.pathname.startsWith("/operators"),
              })}
            >
              <Link to="/operators" className="pointerCursor">
                <span className="icon icon-operators font-size_24 middleContext boldFont"></span>{" "}
                اوپراتور ها
                <span className="icon icon-arrow-down font-size_14 leftFloat arrowPosition"></span>
              </Link>
            </li>
            <li
              className={classNames({
                greenColor: props.location.pathname.startsWith("/settings"),
              })}
            >
              <Link to="/settings" className="pointerCursor">
                <span className="icon icon-Settings font-size_24 middleContext boldFont"></span>{" "}
                اطلاعات پایه
                <span className="icon icon-arrow-down font-size_14 leftFloat arrowPosition"></span>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ events, activeEvent, subscription }) => ({
  events,
  activeEvent,
  subscription,
});

export default connect(mapStateToProps, { setActiveEvent })(
  withRouter(Navigation)
);
